module.exports = __webpack_public_path__ + "static/soon-i-will-be-invincible-e34d12f71af4d65faed394bfc2179577.jpg";